import { render, staticRenderFns } from "./NumberSlide.vue?vue&type=template&id=5e0809ec&scoped=true"
import script from "./NumberSlide.vue?vue&type=script&lang=js"
export * from "./NumberSlide.vue?vue&type=script&lang=js"
import style0 from "./NumberSlide.vue?vue&type=style&index=0&id=5e0809ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0809ec",
  null
  
)

export default component.exports